<div class="section-header">
    <div class="title">
        Hardware
    </div>
</div>

<div class="table"  *ngIf="model.isDeviceOrderRequested">
    <div class="table-header">
        <div class="table-header-column">Anzahl</div>
        <div class="table-header-column">Artikel</div>
        <div class="table-header-column amounts">Mtl. Druckvolumen</div>
    </div>

    <div class="table-body">
        <ng-container *ngFor="let deviceContainer of model.requestedDevicesContainers">
            <div class="table-row device"
                 [ngClass]="{ 'print-smart': isSmartPrint(deviceContainer.itemToOrder)}">
                <div class="amount-column-cell">
                    <app-hovered-disabled-input [textValue]="deviceContainer.deviceAmount?.amount?.toString()">
                    </app-hovered-disabled-input>
                </div>


                <div class="article-column-cell">

                    <div class="product-label-container">
                        <app-product-label [orderItemContainer]="deviceContainer"
                                           [activateHover]="false"></app-product-label>
                    </div>


                    <div class="icon-container" *ngIf="isSmartPrint(deviceContainer.itemToOrder)">
                        <div class="print-smart-icon">
                            <img [res-src]="'./assets/img/logo-print-smart/icon_mps.png'"
                                 [res-sizes]="['2x', '3x']"/>
                        </div>
                    </div>

                </div>


                <div class="price-and-pages-columns">
                    <div class="page-amounts-column-cell">
                        <ng-container *ngIf="isSmartPrint( deviceContainer.itemToOrder )">
                            <app-amount-input
                                [(ngModel)]="deviceContainer.deviceRequest.metaData.monoPageCountPerMonth"
                                [name]="deviceContainer.id + 'monoPageCountPerMonthTest_wevc'"
                                disabled>
                                <img src="./assets/img/icon_printvolume_monochrome.svg"
                                     alt="icon printvolume monochrome">
                            </app-amount-input>
                            <app-amount-input *ngIf="isColorPrinter( deviceContainer.itemToOrder )"
                                              [(ngModel)]="deviceContainer.deviceRequest.metaData.colorPageCountPerMonth"
                                              [name]="deviceContainer.id + 'colorPageCountPerMonth_wevc'"
                                              disabled>
                                <img src="./assets/img/icon_printvolume_cmyk.svg" alt="icon printvolume cmyk">
                            </app-amount-input>
                        </ng-container>

                    </div>
                </div>

            </div>

        </ng-container>
    </div>

</div>

